module.exports = __webpack_public_path__ + "img/shopMessage.034b03f8.svg";